module.exports = __webpack_public_path__ + "static/hasan-minhaj-f73b41590d1f2ec3d24bca050e0a0f9f.jpg";